/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Chat_Commands_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add one command to Nightbot, StreamElements, or Fossabot so viewers can look up any card from your stream chat." |
*
* @param {Help_Article_Chat_Commands_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_chat_commands_description = /** @type {((inputs?: Help_Article_Chat_Commands_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Chat_Commands_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge Nightbot, StreamElements oder Fossabot einen Befehl hinzu, damit Zuschauer jede Karte aus deinem Stream-Chat nachschlagen können.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez une seule commande à Nightbot, StreamElements ou Fossabot pour que vos spectateurs puissent chercher n'importe quelle carte depuis le chat.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("为 Nightbot、StreamElements 或 Fossabot 添加一条命令，让观众能从你的直播聊天中查询任意卡牌。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在 Nightbot、StreamElements 或 Fossabot 加入一個指令，讓觀眾可以從你的直播聊天室查詢任何卡牌。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Nightbot, StreamElements, Fossabot에 명령어 하나만 추가하면 시청자가 방송 채팅에서 어떤 카드든 찾아볼 수 있습니다.")
	return /** @type {LocalizedString} */ ("Add one command to Nightbot, StreamElements, or Fossabot so viewers can look up any card from your stream chat.")
});